import * as types from './types'

const INITIAL_STATE = {
  enabled: [],
  all: [],
}

export function reducer(state = INITIAL_STATE, action) {
  if (action.error) {
    return state
  }
  switch (action.type) {
    case types.ADDED: {
      return {
        ...state,
        enabled: action.payload,
      }
    }
    case types.ALL_ADDED: {
      return {
        ...state,
        all: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
